<template>
    <div class="footer">
        <div class="logo-box">
            <img class="logo" src="../assets/footer-logo.webp" alt="XALIVANDRA PRIVATE LIMITED Logo" />
            <div class="logo-text">XALIVANDRA PRIVATE LIMITED</div>
        </div>
        <div class="contact-list">
            <div class="contact" v-for="(item, index) in list" :key="index">
                <img class="item-icon" :src="item.icon" alt="">
                <div class="item-text">{{ item.title }}</div>
            </div>
        </div>
        <div class="bottom">
            © 2025 Copyright belongs to XALIVANDRA PRIVATE LIMITED
        </div>
    </div>
</template>
<script setup>
const list = [
    {
        title: 'developer@xalivandra.com',
        icon: require('../assets/footer-icon1.webp')
    },
    {
        title: 'First Floor, Plot no 31A, Sector 18, Udyog Vihar, Dlf Qe, Dlf Qe, Gurgaon- 122002, Haryana',
        icon: require('../assets/footer-icon2.webp')
    },
    {
        title: '+91 9749557348',
        icon: require('../assets/footer-icon3.webp')
    },
]
</script>
<style lang="less" scoped>
.footer {
    width: 100%;
    background: #222443;
    padding: 0 270px;
    box-sizing: border-box;

    .logo-box {
        padding-top: 37px;
        display: flex;
        align-items: center;

        .logo {
            width: 60px;
            height: 60px;
            object-fit: cover;
            margin-right: 17px;
        }

        .logo-text {
            font-weight: bold;
            font-size: 24px;
            color: #FFFFFF;
            line-height: 24px;
            letter-spacing: 1px;
            text-shadow: 0px 1px 0px #333333;
        }
    }

    .contact-list {
        margin-top: 40px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 37px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);

        .contact {
            display: flex;

            .item-icon {
                width: 16px;
                height: 16px;
                object-fit: contain;
                margin-right: 8px;
            }

            .item-text {
                max-width: 394px;
                font-weight: 400;
                font-size: 14px;
                color: rgba(255, 255, 255, 0.6);
                line-height: 14px;
                text-shadow: 0px 1px 0px #333333;
            }
        }
    }

    .bottom {
        margin-top: 14px;
        font-weight: 400;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        line-height: 18px;
        text-shadow: 0px 1px 0px #333333;
        text-align: center;
        padding-bottom: 14px;
    }
}
</style>